module.exports = __webpack_public_path__ + "static/media/ManjimupBridgetownTimes-devicecomp-min@2x.cfec02c1.webp";